"use client"

import Link from "next/link"
import { FaTwitter, FaFacebook, FaLinkedin } from "react-icons/fa"
import { usePathname } from "next/navigation"
import { sendFooterClickMail, sendFooterClickMailFerni } from "@/utils/lib/email"

export default function Footer() {
  const year = new Date().getFullYear()
  const pathname = usePathname()

  if (pathname === "/script/result") {
    return (
      <div className="w-full h-10 flex items-end bg-gray-700">
        <p className="ml-auto text-right text-white p-2">© {year} ICAT. All rights reserved.</p>
      </div>
    )
  }

  return (
    <footer className="w-full bg-black text-white border-t border-gray-800">
      <div className="container mx-auto px-6 py-8">
        <div className="text-center mb-8">
          <p className="text-gray-300 mb-2">Designed and developed by</p>
          <div className="flex justify-center items-center gap-6">
            <Link
              href="https://www.linkedin.com/in/lucas-bazan"
              onClick={() => sendFooterClickMail("Lucas Bazan")}
              className="text-white hover:text-blue-400 transition-colors duration-200 font-medium"
            >
              Lucas Bazan
            </Link>
            <span className="text-gray-600">•</span>
            <Link
              href="https://www.linkedin.com/in/nicolasfernandev"
              onClick={() => sendFooterClickMailFerni("Nicolas Fernandez")}
              className="text-white hover:text-blue-400 transition-colors duration-200 font-medium"
            >
              Nicolas Fernandez
            </Link>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-6">
            {/* Copyright */}
            <div className="text-gray-300">
              <p>© {year} ICAT. All rights reserved.</p>
            </div>

            {/* Navigation Links */}
            <div className="flex items-center gap-6">
              <Link href="/terms" className="text-gray-300 hover:text-white transition-colors duration-200 text-sm">
                Terms of Service
              </Link>
              <Link href="/privacy" className="text-gray-300 hover:text-white transition-colors duration-200 text-sm">
                Privacy Policy
              </Link>
            </div>

            <div className="flex items-center gap-4">
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-300 hover:text-blue-400 transition-all duration-200 hover:scale-110"
                aria-label="Follow us on Twitter"
              >
                <FaTwitter className="w-5 h-5" />
              </a>
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-300 hover:text-blue-500 transition-all duration-200 hover:scale-110"
                aria-label="Follow us on Facebook"
              >
                <FaFacebook className="w-5 h-5" />
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-300 hover:text-blue-400 transition-all duration-200 hover:scale-110"
                aria-label="Follow us on LinkedIn"
              >
                <FaLinkedin className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}